const topics = [

    {
      title: "Past & Present",
      slug: "past&present",
      standardNumber: "2.2",
      description: "Civics – The student will apply history and social science skills to understand citizenship.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpastandpresent2025video.mp4?alt=media&token=f07b277a-b4c5-4c69-8d6a-98f1b8db60d4",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpastandpresent2025song.mp3?alt=media&token=9e92f35e-4508-46b6-8cad-47e29e3f5e5f",
      lyrics: ["(chorus)",
"It's the new inventions that helped to change things overtime, overtime.",
"It's the new inventions that helped to change things overtime, overtime.",

"(verse1)",
"In the past buildings were smaller.",
"In the present buildings are taller.",
"In the past they washed clothes by hand in a stream.",
"In the present we wash our clothes in a washing machine.",
"In the past to get around they walked or rode horses.",
"In the present you ride in cars, airplanes, or buses.",
"In the past they used typewriters.",
"In the present we have computers.",
"An invention is something that’s created to make life easier, and we use it.",
"The population was lower in the past, it's much higher currently.",
"The population is the number of people living in a community.",
"A community is a place where people live, work, and play.",
"Transportation is a way of moving people from place to place.",

"(chorus)",
"It's the new inventions that helped to change things overtime, overtime.",
"It's the new inventions that helped to change things overtime, overtime.",

"© Smart Board Learning, LLC. All rights reserved.",
],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Pueblo & Lakota",
      slug: "pueblo&lakota",
      standardNumber: "2.3",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of Indigenous people past and present.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpuebloandlakota2025.mp4?alt=media&token=a06a95af-f5b3-4199-9165-382a48276536",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpuebloandlakota.mp3?alt=media&token=c33cba83-be7e-421e-ba33-fa5431f9ff9f",
      lyrics: ["(chorus)",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Pueblo, I lived in the southwest region.",

"(verse1)",
"We lived in buildings and cliffs that were more than one level.",
"We were farmers and hunters,",
"We were farmers and hunters.",
"We lived in buildings and cliffs that were more than one level,",
"And walking was our means of transportation.",

"(chorus)",
"I’m a Lakota, I lived in the plains.",
"I’m a Lakota, I lived in the plains.",

"(verse2)",
"As Lakota, we made carvings and pottery.",
"As Lakota, we built homes called teepees.",
"As Lakota, we were hunters.",
"As Lakota, we were horseman.",
"I am a Lakota and I have respect for nature.",
"I am a Lakota and I have respect for nature.",

"(chorus)",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Lakota, I lived in the plains.",
"I’m a Lakota, I lived in the plains.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Native Differences",
      slug: "nativedifferences",
      standardNumber: "2.3",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of Indigenous people past and present.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnativedifferences2025video.mp4?alt=media&token=282077e2-3f38-478b-b273-466917fd8e46",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnativedifferences2025song.mp3?alt=media&token=14be9668-7f68-4ab1-a9a7-41a30df34a14",
      lyrics: ["(chorus)",
"Powhatan, eastern Woodlands,",
"Powhatan, eastern Woodlands.",
"Lakota stayed in the Great Plains,",
"while the Pueblo rest in the Southwest.",
"The Natives built homes in",
"different fashions,",
"based on the area they lived in.",
"We know, we know, we know, we know!",

"(verse 1)",
"Powhatan, eastern Woodlands",
"used wood and bark to build houses.",
"Lakota, in the Plains region,",
"they built homes called teepees.",
"Pueblo in the southwest states,",
"they built homes made of clay.",
"Pueblo in the southwest states,",
"they built homes made of clay.",

"(chorus)",
"The Natives worked in different fashions,",
"based on the area they lived in.",
"We know, we know, we know, we know!",

"(verse 2)",
"Powhatan, eastern Woodlands",
"were hunters, farmers, and fishermen.",
"Lakota, in the Plains region,",
"they were hunters and horsemen.",
"The Pueblo in the Southwest",
"were hunters and farmers at their best.",
"The Pueblo in the Southwest",
"were hunters and farmers at their best.",

"(chorus)",
"The Natives traveled in different fashions,",
"based on the area they lived in.",
"We know, we know, we know, we know!",
  
"(verse 3)",
"The Natives traveled in different fashions.",
"Powhatans rode canoes,",
"Lakota walked and rode horseback,",
"Powhatans rode canoes,",
"while the Pueblo walked everywhere",
"that they went.",
"(chorus)",
"Powhatan, eastern Woodlands,",
"Powhatan, eastern Woodlands.",
"Lakota stayed in the Great Plains,",
"while the Pueblo rest in the Southwest.",
"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Ben Franklin",
      slug: "benfranklin",
      standardNumber: "2.4",
      description: "History – The student will apply history and social science skills to recognize state and national symbols.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbenjaminfranklin2025video.mp4?alt=media&token=d3b4d87c-b523-4e1f-89f8-3a030ae0ad62",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbenjaminfranklin2025song.mp3?alt=media&token=931e278a-40ea-405d-acae-a99e4cc1951d",
      lyrics: ["(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 1)",
"Benjamin Franklin invented bifocals.",
"Bifocals or glasses, if you don't know.",
"Benjamin wanted to prove that lightning is electricity.",
"So, Benjamin conducted a famous kite experiment with a key.",
"Benjamin helped to start America's first library.",
"He helped to put streetlights and paved roads in Philadelphia, the city.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 2)",
"The Declaration of Independence was partly written by Benjamin.",
"Benjamin also signed the United States Constitution.",
"Benjamin Franklin was a scientist and an inventor.",
"Benjamin Franklin was a writer and a leader.",
"Benjamin Franklin’s face is on the hundred bill I spent.",
"What Benjamin Franklin was not? He was not President.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Abraham Lincoln",
      slug: "abrahamlincoln",
      standardNumber: "2.4",
      description: "History – The student will apply history and social science skills to recognize state and national symbols.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fabrahamlincoln2025video.mp4?alt=media&token=37424f34-5f48-4d9f-af6a-526d9b14872d",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fabrahamlincoln.mp3?alt=media&token=bae458d6-0b42-4392-aeb4-3d24c7adc90d",
      lyrics: ["(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 1)",
"Abraham Lincoln, a President of mine,",
"was born February 12, 1809.",
"Abraham Lincoln was born in Kentucky.",
"Abraham Lincoln really loved to read.",
"On his father's farm he would chop down trees",
"and plowed the land.",
"He helped his family.",
"When Abraham grew up, he worked in a store.",
"Abraham became a mailman, then he became a lawyer.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 2)",
"Abraham Lincoln made a life choice",
"when he married Mary Todd and they had four boys.",
"Then Abraham Lincoln, a United States resident",
"became the 16th president.",
"During Abraham’s presidency",
"the Civil War began, a very long time for our country.",
"Abraham Lincoln was a great leader.",
"He freed the slaves and held our country together.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Equal Rights",
      slug: "equalrights",
      standardNumber: "2.4",
      description: "History – The student will apply history and social science skills to recognize state and national symbols.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fequalrights2025video.mp4?alt=media&token=58d730cc-6d5a-4889-b630-808aeabd908c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fequalrights2025song.mp3?alt=media&token=50a0be6b-0647-4069-a91b-12e34874e477",
      lyrics: ["(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"(verse)",
"Susan B. Anthony helped women get equal rights.",
"That included the right to vote, that included the right to vote.",

"Jackie Robinson was the first African American",
"to play baseball in the major league, to play baseball in the major league.",

"Martin Luther King Jr. was an African American Minister",
"who worked for equal rights for all people.",

"Thurgood Marshall was a lawyer and the first African American Justice",
"of the U.S. Supreme Court, of the U.S. Supreme Court.",

"Rosa Parks was an African American woman who refused",
"to give up her seat, and that led to a boycott",
"that helped change laws, change laws.",

"(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Dr. King",
      slug: "drking",
      standardNumber: "2.4",
      description: "History – The student will apply history and social science skills to recognize state and national symbols.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdrmartinlutherkingjr2025video.mp4?alt=media&token=df730bc0-7199-4a8b-bf51-509505e2a40c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdrmartinlutherking2025song.mp3?alt=media&token=cfe6a225-2726-4001-8161-8d5dcff1c13d",
      lyrics: ["(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"(Verse)",
"Dr. Martin Luther King Jr. was an African American man.",
"His father was a minister and Martin was a good student.",
"He was born in 1929 on January 15th.",
"He began college when he was only 15.",
"Dr. Martin Luther King Jr. became a minister just like his dad.",
"He worked hard to change laws that were unfair.",
"Dr. Martin Luther King Jr. gave his famous speech, I Have a Dream.",
"He was killed one day because he fought for what he believed.",

"(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved."],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Holidays",
      slug: "holidays",
      standardNumber: "2.5",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of Indigenous people past and present.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fholidays3rdgradeva.mp4?alt=media&token=9b8c3d1d-efbb-476b-b040-86df66f25236",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fholidays3rdgrade2022.mp3?alt=media&token=b1ef8a09-e63d-4a65-817e-eb1bdfccc528",
      lyrics: ["(Verse)",
"One day in January we remember",
"a man who worked hard so all people would be treated equal.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",

"One day in February is for the greats.",
"We honor all presidents of The United States.",
"It’s a holiday,",
"Presidents Day.",
"It’s a holiday,",
"Presidents Day.",

"One day in May we remember",
"Americans who died during war while serving our country.",
"It’s a holiday,",
"Memorial Day.",
"It’s a holiday,",
"Memorial Day.",

"On the Fourth of July we celebrate",
"becoming a new country, America’s birthday.",
"It’s a holiday,",
"Independence Day, The 4th of July.",
"It’s a holiday,",
"Independence Day, The 4th of July.",

"One day in November we remember",
"Americans who served in the military.",
"It’s a holiday,",
"Veterans Day.",
"It’s a holiday,",
"Veterans Day.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Continents & Oceans",
      slug: "continentsandoceans",
      standardNumber: "2.6",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of European explorers.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontinentsandoceans2021.mp4?alt=media&token=dfa953f5-3c7a-4eaa-8324-7c30ad8495ab",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontinentsandoceans2025song.mp3?alt=media&token=8009685b-ddfb-459c-b393-739b04808f60",
      lyrics: ["(Verse)",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",

"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Hemisphere",
      slug: "hemisphere",
      standardNumber: "2.6",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of European explorers.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhemispheres.mp4?alt=media&token=34d76b2b-6ca8-48ac-b82a-01058a8c7d8f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F(3.5b)%20HEMISPHERES.mp3?alt=media&token=d83a018b-9d2c-4351-88b8-c299d2f08752",
      lyrics: ["(verse)",
"The prime meridian divides the Earth, divides the Earth,",
"into the Eastern hemisphere, into the Western hemisphere.",
"The prime meridian is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"The equator divides the Earth, divides the Earth,",
"into the Northern hemisphere, into the Southern hemisphere.",
"The equator is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"The equator divides the Earth, divides the Earth,",
"into the Northern hemisphere, into the Southern hemisphere.",
"The equator is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Coordinates",
      slug: "coordinates",
      standardNumber: "2.6",
      description: "History – The student will use history and social science skills to identify the geographic location, use of resources, and contributions of European explorers.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcoordinates2025video.mp4?alt=media&token=da24a868-2bbf-4c8c-acbd-93c47d9f28bd",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcoordinates2025song.mp3?alt=media&token=4e3cd02c-f4d9-4079-9a6d-8854fc2d2c1e",
      lyrics: ["(chorus)",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",

"(verse)",
"Just look for the letter on the left, on the left.",
"Then, find the number at the bottom of the map.",
"Next, we’ll go to the spot where the letter and the number meet,",
"and that will be your location.",
"Just look for the letter on the left, on the left.",
"Then, find the number at the bottom of the map.",
"Next, we’ll go to the spot where the letter and the number meet,",
"and that will be your location.",

"(chorus)",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Native Contributions",
      slug: "nativecontributions",
      standardNumber: "2.7",
      description: "History – The student will apply history and social science skills to describe the revolutionaries who fought for America’s freedom (1764–1781).",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnativecontributions2025video.mp4?alt=media&token=ac5568b5-1a71-46c5-bd19-d1f7a1d74277",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnativedifferences2025song.mp3?alt=media&token=14be9668-7f68-4ab1-a9a7-41a30df34a14",
      lyrics: ["(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"(verse 1)",
"Native American culture taught us things that live on.",  
"They taught us about the farming of tobacco,",  
"they taught us about the farming of corn.",  
"Native American culture taught us things we can't forget.",  
"We learned to respect nature and gain knowledge of the environment.",  
"Native American culture brought things we love in the heart.",  
"They brought us pottery, weaving, carving, and different types of arts.",  

"(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Native Climate",
      slug: "nativeclimate",
      standardNumber: "2.7",
      description: "History – The student will apply history and social science skills to describe the revolutionaries who fought for America’s freedom (1764–1781).",
      video: "",
      music: "",
      lyrics: [],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Natural Resources",
      slug: "naturalresources",
      standardNumber: "2.8",
      description: "History – The student will apply history and social science skills to understand the principles of American democracy and relate them to the founding of the nation.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
      lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Barter",
      slug: "barter",
      standardNumber: "2.9",
      description: "History – The student will apply history and social science skills to understand key events in United States history.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbarter2025video.mp4?alt=media&token=6345df74-466e-458e-b8c2-923c150215eb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbarter2025song.mp3?alt=media&token=8ac562f6-6b71-49da-9b5c-7044b49d009a",
      lyrics: ["(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Most people did not have paper money.",
"Most people did not have coins.",
"Most people did not have paper money.",
"Most people did not have coins.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Barter means trading, barter means trading,",
"Or exchanging of goods without using money.",
"Tobacco was used as money.",
"You could trade tobacco for goods and services.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Producer",
      slug: "producer",
      standardNumber: "2.10",
      description: "History – The student will describe the contributions and roles of changemakers in United States history.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fproducer2025video.mp4?alt=media&token=927f12da-8625-49c4-9b45-c6dc89b4ae06",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fproducer2025song.mp3?alt=media&token=9907f02f-44ae-4bdc-a63d-241c0140ca0d",
      lyrics: ["(verse)",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"When resources are scarce, that means limited resources,",
"limited resources.",
"When resources are scarce, that means limited resources,",
"limited resources.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Responsible Citizen",
      slug: "responsiblecitizen",
      standardNumber: "2.11",
      description: "Geography – The student will apply history and social science skills to develop geographic mapping skills using world maps and globes.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fresponsiblecitizen2025video.mp4?alt=media&token=c686e9e2-9c58-4d29-88ac-75835950a857",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fresponsiblecitizen2025song.mp3?alt=media&token=4fe0f14e-695b-4155-8ad4-696cbe08b452",
      lyrics: ["(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"(Verse)",
"Responsible citizens have civic duties.",
"Responsible citizens obey laws.",
"Responsible citizens serve on a jury,",
"Or as a witness, if they are called.",
"Responsible citizens have civic duties.",
"Responsible citizens pay their taxes.",
"Responsible citizens serve in the armed forces,",
"If they are called.",

"(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "VA United",
      slug: "vaunited",
      standardNumber: "2.12",
      description: "Geography – The student will apply history and social science skills to connect geography to landmarks and historic events.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvaunited2025video.mp4?alt=media&token=5687815e-0c5a-4aa3-9573-e603b4d5794c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvaunited2025song.mp3?alt=media&token=4f534d13-dc31-4abb-a545-15440b28d24f",
      lyrics: ["(verse)",
"We, the people of Virginia, are united.",
"We are Americans, we are Americans.",
"We, the people of Virginia, are united.",
"We vote in elections, vote in elections.",
"We, the people of Virginia, are united.",
"Elect local governments, elect local governments to help make a better place to work and live.",
"We, the people of Virginia, are united.",
"Come from different places, many different races.",
"We, the people of Virginia, are united.",
"Come from different places, many different races.",
"We, the people of Virginia, are united.",
"By volunteering and helping our community.",
"We, the people of Virginia, are united.",
"We are Americans, we are Americans.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
   
    {
      title: "Pledge",
      slug: "pledge",
      standardNumber: "2.13",
      description: "Economics – The student will apply history and social science skills to understand basic economic principles.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpledge.mp4?alt=media&token=c4877dc3-d775-42d5-b8e0-960352101e3f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpledge.mp3?alt=media&token=c712b543-9b61-437e-944c-02c04b85a3eb",
      lyrics: ["(verse)",
"The leader of the United States",
"is the President, is the President.",
"The leader of the United States",
"is the President, is the President.",

"(verse)",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"(verse)",
"I pledge allegiance to the Flag of the United States of America,",
"and to the Republic for which it stands, one Nation under God, indivisible, with liberty and justice for all.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
  
];
export default topics;
